let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hL1BA")).then(() => parcelRequire('ipdqX'));